/**
 * Funkce pro přidání "vizuálního efektu" pro zobrazení aktualizací dat zadaného HTML elementu.
 * Animace načítání 'zoom-effect' je přidávána do elementu a po uplynutí 1.5 sekundy je odebírána.
 *
 * @param element - HTMLElement, kterému má být přidán efekt načítání.
 */
export const updateLoadingEffect = (element: HTMLElement | null) => {
  if (!element) return;

  // Přidání CSS třídy 'zoom-effect' k elementu
  element.classList.add('zoom-effect');

  // Odebrání CSS třídy 'zoom-effect' po uplynutí 1.5 sekundy
  setTimeout(() => element.classList.remove('zoom-effect'), 1500);
};
